const _excluded = ["isOpen", "selectedItems", "getSelectedItemProps", "removeSelectedItem", "getInputProps", "itemToString", "placeholder", "renderInput", "renderItems", "renderPlaceholder", "getToggleButtonProps", "disabled"],
  _excluded2 = ["style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ControlLabel from './ControlLabel';
import Placeholder from './Placeholder';
import Selected from './Selected';
import { defaultLabelGetter } from '../../helpers/defaultGetters';
const MultiControlWrapped = (_ref, ref) => {
  let {
      isOpen = false,
      selectedItems,
      getSelectedItemProps,
      removeSelectedItem,
      getInputProps,
      itemToString = item => defaultLabelGetter(item),
      placeholder,
      renderInput: renderInputProp,
      renderItems = () => /*#__PURE__*/React.createElement(Selected, {
        selectedItems: selectedItems,
        itemToString: itemToString
      }),
      renderPlaceholder = placeholderProps => /*#__PURE__*/React.createElement(Placeholder, placeholderProps),
      getToggleButtonProps,
      disabled
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const hasSelectedItems = !!selectedItems && !!selectedItems.length;
  const renderInput = () => {
    if (!renderInputProp || !getInputProps) {
      return null;
    }
    const _getInputProps = getInputProps({
        readOnly: !isOpen,
        disabled
      }),
      {
        style
      } = _getInputProps,
      inputProps = _objectWithoutProperties(_getInputProps, _excluded2);
    return renderInputProp(_objectSpread(_objectSpread({}, inputProps), {}, {
      style: style,
      isOpen
    }));
  };
  return /*#__PURE__*/React.createElement(ControlLabel, _extends({
    ref: ref,
    isOpen: isOpen,
    getToggleButtonProps: getToggleButtonProps,
    disabled: disabled
  }, props), hasSelectedItems && renderItems && renderItems({
    isOpen,
    selectedItems,
    getSelectedItemProps,
    removeSelectedItem,
    itemToString
  }), renderInput(), !hasSelectedItems && renderPlaceholder({
    children: placeholder
  }));
};
const MultiControl = /*#__PURE__*/React.forwardRef(MultiControlWrapped);
MultiControl.displayName = 'MultiControl';
MultiControl.propTypes = _objectSpread({}, ControlLabel.propTypes);
export default MultiControl;
//# sourceMappingURL=MultiControl.js.map